export default __webpack_public_path__ + "static/media/painscale_7.674c9afd.png";